import { useState, useCallback } from "react";

export const useModulesUsage = () => {
  const [usageAnswers, setUsageAnswers] = useState<{
    [questionId: string]: string;
  }>({});

  const onAnswersUsage = useCallback((questionId: string, value: string) => {
    setUsageAnswers((prev) => {
      if (prev[questionId] === value) {
        delete prev[questionId];
        return { ...prev };
      }
      return { ...prev, [questionId]: value };
    });
  }, []);

  return { usageAnswers, onAnswersUsage };
};
